module.exports = __webpack_public_path__ + "img/brushes_cn.f334539.jpg";